const cs = {
  banner: {
    title: 'Chytrá cesta ke štíhlému tělu',
    subtitle: 'Přírodní spalovač tuků pro dosažení vašich cílů',
    cta: 'Vybrat balení',
    slide1: 'Viditelné výsledky do 10 dnů',
    slide2: 'Přestaňte si píchat Ozempic',
    slide3: 'Více energie, méně hladu',
  },
    about: {
      title: 'Jak to funguje',
      description: 'Naše kapsle zrychlují metabolismus a snižují chuť k jídlu bez vedlejších účinků.',
      feature1: 'Přírodní složky',
      feature2: 'Rychlé výsledky',
      feature3: 'Bezpečné a certifikované',
    },
    buy: {
      title: 'Vyberte si balení',
      pack1: '10 kapslí',
      pack2: '30 kapslí',
      pack3: '100 kapslí',
      cta: 'Koupit nyní',
    },
    faq: {
      title: 'Otázky a odpovědi',
      q1: 'Jak bezpečný je tento přípravek?',
      a1: 'Tento lék je testován a zcela bezpečný při dodržení dávkování a kontraindikací.',
      q2: 'Jak často se lék užívá?',
      a2: 'Užívejte jednou denně, nalačno, hodinu před snídaní. Nedoporučuje se užívat odpoledne kvůli možným problémům se spánkem.',
      q3: 'Kdo je výrobcem léku?',
      a3: 'Výrobcem a dodavatelem je společnost "Lannet", USA.',
      q4: 'Kde si mohu přečíst oficiální návod?',
      a4: 'Oficiální návod najdete na webových stránkách výrobce.',
      q5: 'Jaké jsou první pocity po užití kapsle?',
      a5: 'Za 20–30 minut pocítíte příval energie a dlouhodobé potlačení hladu.',
      q6: 'Jak probíhá platba a doručení?',
      a6: 'Platbu lze provést bankovním převodem nebo na dobírku při převzetí na poště.',
      q7: 'Vznikne na přípravek závislost?',
      a7: 'Při správném užívání dle návodu výrobce nevzniká po ukončení léčby žádná závislost.',
    },
    contact: {
      title: 'Objednávka / Kontakt',
      name: 'Vaše jméno',
      email: 'Váš e-mail',
      phone: 'Vaše telefonní číslo',
      message: 'Zpráva nebo informace o produktu',
      send: 'Odeslat',
      success: '✅ Zpráva byla odeslána!',
      error: '❌ Chyba při odesílání. Zkuste to znovu.',
      notify: 'Nová objednávka z webu Body Harmony',
    },
    
  }
  
  export default cs
  